import { Badge } from "@/ui/badge"
import styles from "./StatusBadge.module.scss"

type StatusType = "active" | "inactive" | "verified" | "unverified"

export function StatusBadge({ type, labelOverride }: { type: StatusType; labelOverride?: string }) {
    const config = {
        active: {
            label: "Active",
            className: styles.active,
        },
        inactive: {
            label: "Inactive",
            className: styles.inactive,
        },
        verified: {
            label: "Verified",
            className: styles.verified,
        },
        unverified: {
            label: "Unverified",
            className: styles.unverified,
        },
    }

    const { label, className } = config[type]

    return (
        <Badge
            variant="outline"
            className={`${styles.badgeContent} ${className}`}
        >
            <span className={styles.dot} />
            {labelOverride ?? label}
        </Badge>
    )
}